"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ListSubheader_1 = __importDefault(require("@mui/material/ListSubheader"));
var styles_1 = require("@mui/material/styles");
var colors_1 = require("../ThemeProvider/colors");
var StyledListSubheader = (0, styles_1.styled)(ListSubheader_1.default, {
    name: 'PrismListSubheader',
})({
    color: colors_1.tannerGray['600'],
    fontSize: 12,
    lineHeight: 1.3,
    paddingTop: 8,
    paddingBottom: 6,
    pointerEvents: 'none', // workaround for https://github.com/mui-org/material-ui/issues/18200
});
var ListSubheader = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return react_1.default.createElement(StyledListSubheader, __assign({}, props), children);
};
exports.default = ListSubheader;
//# sourceMappingURL=index.js.map